import { __values } from "tslib";
import { NotificationItem, NotificationStatus } from 'client/angular/core/components/notification-bell/model/notification-item.model';
var NavbarController = /** @class */ (function () {
    /*@ngInject*/
    function NavbarController(Auth, $scope, Util, NavbarService, ProductService, CartService, $compile, $window, $sce, $state, $location, $rootScope, $log, OrderService, $timeout, EducationSubNavService, SearchService, SettingsService, CommonDataService, notifyBellService, unleashFeatureService, googleAnalytic, configurationService) {
        var _this = this;
        this.isCollapsed = true;
        this.mobileMenuToggle = 0;
        this.bannerMessage = '';
        this.showBannerMessage = false;
        this.subTotal = 0;
        this.quantityOfCartItems = 0;
        this.freeShipping = 250;
        this.sortOptions = ['Products', 'Content'];
        this.sortOption = null;
        this.sortListVisible = false;
        this.isSortPlaceholder = true;
        this.sortPlaceholder = 'Products';
        this.sortSelected = '';
        this.sortProperty = '';
        this.cartList = [];
        this.isValidRecentOrderQty = false;
        this.toggleWelcomeMenu = false;
        this.menuPlaceholder = 'Recent Orders';
        this.selectedMenuOption = 'Recent Orders';
        this.timerNav = null;
        this.timerNavShop = null;
        this.timerNavNormal = null;
        this.menuOptions = [
            {
                title: 'Recent Orders',
                value: 'Recent Orders',
            },
            {
                title: 'Quick Order',
                value: 'Quick Order',
            }
        ];
        this.isMicrosoftBrowser = false;
        this.hasAddedNotification = false;
        this.displaySsoModalOnlogin = false;
        this.selectMenuOption = function (menu) {
            this.selectedMenuOption = menu.value;
            this.menuPlaceholder = menu.value;
        };
        this.select = function (item) {
            this.isSortPlaceholder = false;
            this.sortSelected = item;
            this.sortListVisible = false;
            this.display = item;
        };
        this.isSelected = function (item) {
            return item[this.sortProperty] === this.sortSelected[this.sortProperty];
        };
        this.searchResults = function () {
            console.log("searching results");
        };
        this.isQaEnvironment = function () {
            var host = window.location.hostname;
            return (host === "localhost" || host === "ares-www.qa.emersonecologics.com");
        };
        this.setCurrentItem = function (itemId, isMobile) {
            var _this = this;
            if (isMobile && itemId === this.currentItem) {
                this.currentItem = null;
                this.currentMenuItem = null;
                return;
            }
            self.$timeout.cancel(this.timerNav);
            self.$timeout.cancel(this.timerNavShop);
            self.$timeout.cancel(this.timerNavNormal);
            this.currentMenuItem = itemId;
            this.timerNavNormal = self.$timeout(function () {
                _this.$scope.displayMegaMenu = false;
                _this.currentItem = itemId;
                _this.$scope.$apply();
            }, 500);
            // if mobile menu is open - close when user clicks on search or cart
            //if(this.currentItem == 8 || this.currentItem == 9) {
            //  this.mobileMenuToggle = null;
            //}
        };
        this.setCurrentDirectItem = function (itemId, isMobile) {
            if (isMobile && itemId === this.currentItem) {
                this.currentItem = null;
                this.currentMenuItem = null;
                return;
            }
            this.currentMenuItem = itemId;
            this.$scope.displayMegaMenu = false;
            this.currentItem = itemId;
        };
        this.setCurrentShopItem = function (itemId, displayMegaMenu) {
            var _this = this;
            self.$timeout.cancel(this.timerNav);
            self.$timeout.cancel(this.timerNavShop);
            self.$timeout.cancel(this.timerNavNormal);
            this.currentMenuItem = itemId;
            this.timerNavShop = self.$timeout(function () {
                _this.currentItem = itemId;
                _this.$scope.displayMegaMenu = displayMegaMenu;
                _this.$scope.$apply();
            }, 500);
        };
        this.setMobileMenuToggle = function (itemId) {
            if (itemId == this.mobileMenuToggle) {
                this.mobileMenuToggle = null;
            }
            else {
                this.mobileMenuToggle = itemId;
                this.currentItem = 0;
                this.currentMenuItem = 0;
            }
        };
        this.closeAllNavItem = function () {
            this.currentItem = null;
            this.currentMenuItem = null;
            this.mobileMenuToggle = null;
            this.eduSubNavService.level = '1';
        };
        this.closeAllNavItemDesktop = function () {
            this.currentItem = null;
            this.currentMenuItem = null;
        };
        this.closeAllNavItemTimeout = function () {
            var _this = this;
            self.$timeout.cancel(this.timerNavShop);
            self.$timeout.cancel(this.timerNavNormal);
            this.timerNav = $timeout(function () {
                _this.closeAllNavItem();
                _this.$scope.displayMegaMenu = false;
            }, 900);
        };
        this.checkForRestrictedItem = function (cartVal) {
            var _this = this;
            this.CartService.setExpressCheckoutStatus(false);
            this.CartService.removedRestrictedProduct(this.items)
                .then(function (response) {
                if (response && response.status === 200) {
                    if (_this.CartService.isItemRemoved) {
                        if (cartVal === 'checkOut') {
                            _this.$state.go('cart');
                        }
                        else {
                            _this.$state.reload();
                        }
                    }
                }
            });
            if (cartVal === 'checkOut') {
                this.$state.go('shippingAndDelivery');
            }
            else {
                this.$state.go('cart');
            }
        };
        this.linkPreventDefault = function (e) {
            e.preventDefault();
        };
        //$scope.$window = $window;
        this.getBannerMessage = function (contentId) {
            var _this = this;
            var ctrl = this;
            return this.NavbarService.getContent(contentId)
                .then(function (response) {
                if (response.data.response) {
                    ctrl.bannerMessage = _this.$sce.trustAsHtml(response.data.response.detail);
                    ctrl.showBannerMessage = true;
                }
                else {
                    ctrl.showBannerMessage = false;
                }
            });
        };
        this.closeAlert = function () {
            this.showBannerMessage = false;
            //document.getElementById('navbar').classList.remove("topPos");
        };
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.searchResults = function () {
            $state.go('searchResults');
        };
        this.closeMegaNav = function () {
            setTimeout(function () {
                document.getElementById('mega-menu-shop-by').style.display = "none";
            }, 0);
        };
        this.isFreeShipping = function () {
            if (this.couponCodes && this.shipVia) {
                return this.shipCost - this.totalShippingDiscount == 0;
            }
            return 0;
        };
        this.toggleCartList = function (itemCode, quantity) {
            var idx = this.cartList.findIndex(function (item) { return item.itemCode == itemCode; });
            if (idx > -1) {
                this.cartList.splice(idx, 1);
            }
            else {
                this.cartList.push({ itemCode: itemCode, quantity: quantity });
            }
            this.checkInvalidRecentItems();
        };
        this.changeQuantity = function (itemCode, quantity) {
            var _this = this;
            var idx = this.cartList.find(function (item) {
                if (item.itemCode == itemCode) {
                    item.quantity = quantity;
                }
                _this.checkInvalidRecentItems();
            });
        };
        this.clearQuantity = function (itemId) {
            this.recentOrders.forEach(function (recentOrder) {
                if (recentOrder.itemId == itemId) {
                    recentOrder.quantityOrdered = '';
                }
            });
            var idx = this.cartList.findIndex(function (item) { return item.itemCode == itemId; });
            if (idx > -1) {
                this.cartList[idx].quantity = '';
                this.isValidRecentOrderQty = false;
            }
            else {
                this.isValidRecentOrderQty = true;
            }
        };
        this.exists = function (itemCode, quantity) {
            var idx = this.cartList.findIndex(function (item) { return item.itemCode == itemCode; });
            return idx > -1;
        };
        this.checkoutCart = function () {
            var _this = this;
            this.$rootScope.loading = true;
            var itemList = this.cartList.map(function (item) {
                var returnItem = {};
                returnItem.itemId = item.itemCode;
                returnItem.quantity = item.quantity;
                return returnItem;
            });
            this.CartService.addItems(itemList)
                .then(function () {
                var e_1, _a;
                var adobeCartData = {
                    cart: { item: [] },
                    cartInfo: { isFirstCart: false }
                };
                try {
                    for (var itemList_1 = __values(itemList), itemList_1_1 = itemList_1.next(); !itemList_1_1.done; itemList_1_1 = itemList_1.next()) {
                        var item = itemList_1_1.value;
                        adobeCartData.cart.item.push({ productInfo: { productID: item.itemId } });
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (itemList_1_1 && !itemList_1_1.done && (_a = itemList_1.return)) _a.call(itemList_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                adobeCartData.cartInfo.isFirstCart = _this.CartService.cartData.aresLineItems.length === 0;
                _this.$state.go('cart');
            })
                .catch(function (err) {
                if (err) {
                    _this.Util.flattenWarnings('An error occurred while processing your request.');
                }
            })
                .finally(function () {
                _this.$rootScope.loading = false;
            });
        };
        this.isAdmin = Auth.isAdminSync;
        this.Auth = Auth;
        this.$scope = $scope;
        this.NavbarService = NavbarService;
        this.ProductService = ProductService;
        this.CartService = CartService;
        this.orderService = OrderService;
        this.$sce = $sce;
        this.$state = $state;
        this.$log = $log;
        this.Util = Util;
        this.$timeout = $timeout;
        this.isRecentOrder = true;
        this.eduSubNavService = EducationSubNavService;
        this.mobileShopItemsOpen = 0;
        this.$rootScope = $rootScope;
        this.blockCheckOut = false;
        this.SearchService = SearchService;
        this.SettingsService = SettingsService;
        this.CommonDataService = CommonDataService;
        this.notificationBellService = notifyBellService;
        this.unleashSvc = unleashFeatureService;
        this.$location = $location;
        this.ga = googleAnalytic;
        this.configurationService = configurationService;
        this.environmentConfiguration = this.configurationService.getEnvironmentConfiguration();
        this.signupUrl = this.environmentConfiguration.registrationServiceUrl + 'emerson/register';
        this.isImpersonated = false;
        this.multiCartList = [];
        this.selectedCartId = null;
        this.storeFrontId = null;
        this.displaySsoModal = false;
        this.userIsLoggedIn = false;
        var self = this;
        this.$rootScope.$on('$stateChangeSuccess', function (evt, toState, fromState, fromParams) {
            _this.$scope.displayMegaMenu = false;
            _this.$scope.mobileMenu = false;
            _this.mobileMenuToggle = null;
            if (toState.name != 'logout') {
                _this.Auth.isLoggedIn(function (user) {
                    if (user && user.isImpersonated) {
                        _this.storeFrontId = user.storefrontId;
                        _this.loadCarts(null);
                    }
                });
            }
        });
        //on load scroll to the top of the page.
        var currentUserAgent = $window.navigator.userAgent;
        var sec = 50;
        if (currentUserAgent.indexOf('Trident') > 0 || currentUserAgent.indexOf('MSIE') > 0) {
            sec = 1000;
        }
        else {
            sec = 50;
        }
        $window.onload = function () {
            self.$timeout(function () {
                $window.scrollTo(0, 0);
            }, sec);
        };
        self.getBannerMessage(9018);
        self.shopCondition = function (conditionName, taxonomyId) {
            var filterValue = this.urlStrip(conditionName) + '-D' + taxonomyId;
            $state.transitionTo('searchResults', { searchFilter: filterValue }); // switch views to the results page.
        };
        self.shopcategory = function (category, taxonomyId) {
            var filterValue = this.urlStrip(category) + '-C' + taxonomyId;
            $state.transitionTo('searchResults', { searchFilter: filterValue }); // switch views to the results page.
        };
        self.shopsubcategory = function (subCategory, taxonomyId) {
            var filterValue = this.urlStrip(subCategory) + '-S' + taxonomyId;
            $state.transitionTo('searchResults', { searchFilter: filterValue }); // switch views to the results page.
        };
        self.shopbrand = function (brandName, brandId) {
            var filterValue = this.urlStrip(brandName) + '-B' + brandId;
            $state.transitionTo('searchResults', { searchFilter: filterValue }); // switch views to the results page.
        };
        self.shopqualitypartners = function () {
            var state = {
                ff: ['Gold', 'Silver'],
                fft: 'q',
                term: '*',
                q: ['Gold', 'Silver'],
            };
            SearchService.clickedSearchTerm = '';
            $state.go('advSearchResults', state, { inherit: false }); //switch views to the results page.
        };
        self.shopNewProducts = function () {
            var state = {
                ff: '1',
                fft: 'new',
                term: '*',
                new: '1'
            };
            $state.go('advSearchResults', state, { inherit: false });
        };
        self.urlStrip = function (str) {
            if (str) {
                return str.replace(/[^\w\d\s]*/g, '').replace(/\s+/g, '-');
                // strip special characters and join words with '-'
            }
            else {
                return 'undefined'; // default value brand
            }
        };
        NavbarService.getBlog()
            .then(function (response) {
            _this.blog = response.blog;
        });
        ProductService.getConditionTaxonomies()
            .then(function (response) {
            _this.conditions = response;
        });
        this.categories = NavbarService.navbarCategories;
        NavbarService.getFeaturedProducts()
            .then(function (response) {
            _this.products = response;
            _this.CommonDataService.addAttributeProductPathsForAllItems(_this.products);
        });
        NavbarService.getFeaturedShopMenuBrands()
            .then(function (response) {
            _this.shopMenuBrands = response;
        });
        NavbarService.getFeaturedMegaMenuBrands()
            .then(function (response) {
            _this.megaMenuBrands = response;
        });
        NavbarService.getFrequentlyOrderedItems()
            .then(function (response) {
            _this.frequentItems = response;
        });
        NavbarService.getEducation()
            .then(function (response) {
            var resp = {
                "response": {
                    "contentID": 1076,
                    "contentTypeId": 9009,
                    "header": null,
                    "topic": null,
                    "keywords": null,
                    "associatedDate": null,
                    "author": null,
                    "excerpt": null,
                    "detail": "<div flex=\"25\" flex-xs=\"100\" flex-sm=\"100\" class=\"sub-menu-padding\">                        \n<div layout=\"row\" layout-xs=\"column\" class=\"layout-xs-column layout-row\">                          \n<div flex=\"\" class=\"flex\">                            \n<ul class=\"list-unstyled\">                              \n<li><a href=\"https://www.emersonecologics.com/blog\" target=\"_blank\" ng-click=\"$ctrl.closeAllNavItem()\">blog</a></li>                              \n<li><a href=\"https://www.emersonecologics.com/blog/category/emerson-experts\" target=\"_blank\" ng-click=\"$ctrl.closeAllNavItem()\">experts</a></li>                              \n<li><a href=\"https://www.emersonecologics.com/education/clinical-resources\" target=\"_blank\" ng-click=\"$ctrl.closeAllNavItem()\">resources</a></li>                            </ul>                          </div>                        </div>                      </div>                      \n<div flex=\"75\" flex-xs=\"100\" flex-sm=\"100\" class=\"\">                        \n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" class=\"layout-xs-column layout-row\">                          \n<div flex=\"\" class=\"md-padding flex\">                            \n<ul class=\"list-unstyled ee-media\">                              \n<li>                             \n<div class=\"media-block\">                                  \n<div class=\"image\"><a href=\"https://www.emersonecologics.com/blog\" target=\"_blank\" ng-click=\"$ctrl.closeAllNavItem()\"><img alt=\"blog\" src=\"https://images.emersonecologics.com/Webcontent/banner/20-1-web-nav-image-blog.png\" /></a></div>                                    \n<div class=\"body\">                                                                           \n<p></p><a href=\"https://www.emersonecologics.com/blog\" class=\"avbar-nav-li-content-a\" target=\"_blank\" ng-click=\"$ctrl.closeAllNavItem()\"><center>Guidance on supplements and practice management in articles, interviews, videos and webinars</center></a>\n<p></p>                                  </div>                                                            </div></li></ul>                          </div>                          \n<div flex=\"\" class=\"md-padding flex\">                            \n<ul class=\"list-unstyled ee-media\">                              \n<li>                                \n<div class=\"media-block\">                                  \n<div class=\"image\"><a href=\"https://www.emersonecologics.com/blog/category/emerson-experts\" target=\"_blank\" ng-click=\"$ctrl.closeAllNavItem()\"><img alt=\"experts\" src=\"https://images.emersonecologics.com/Webcontent/banner/20-1-web-nav-image-experts.png\" /></a></div>                                  \n<div class=\"body\">                   \n<p></p><a href=\"https://www.emersonecologics.com/blog/category/emerson-experts\" target=\"_blank\" ng-click=\"$ctrl.closeAllNavItem()\"><center>Stay up-to-date on best practices, protocols and research from Emerson's Medical Advisory Board and team of medical experts</center></a>\n<p></p>                                  </div>                                </div>                              </li>                            </ul>                          </div>                          \n<div flex=\"\" class=\"md-padding flex\">                            \n<ul class=\"list-unstyled ee-media\">                              \n<li>                                \n<div class=\"media-block\">                                  \n<div class=\"image\"><a href=\"https://www.emersonecologics.com/education/clinical-resources\" target=\"_blank\" ng-click=\"$ctrl.closeAllNavItem()\"><img alt=\"resources\" src=\"https://images.emersonecologics.com/Webcontent/banner/20-1-web-nav-image-resources.png\" /></a></div>                                  \n<div class=\"body\">                                      \n<p></p><a href=\"https://www.emersonecologics.com/education/clinical-resources\" target=\"_blank\" ng-click=\"$ctrl.closeAllNavItem()\"><center>Access supplement and health condition databases for real-time, research-driven information</center></a>\n<p></p>                                  </div>                                </div>                              </li>                            </ul>                          </div>                        </div>                      </div>",
                    "displayOrder": 0,
                    "startDate": "2016-12-01T00:00:00",
                    "endDate": "2099-12-05T00:00:00",
                    "status": 4,
                    "enabled": 1,
                    "trackingOnClick": null,
                    "createDate": "2016-12-05T15:05:10",
                    "createdBy": "jharty",
                    "updateDate": "2017-03-10T14:19:41.337",
                    "updatedBy": "jharty"
                },
                "errors": [],
                "warnings": []
            };
            _this.education = resp.response;
        });
        NavbarService.getQuality()
            .then(function (response) {
            _this.quality = response.data.response;
        });
        NavbarService.getShopQuality()
            .then(function (response) {
            _this.shopQuality = response.data.response;
        });
        this.Auth.subscribe($scope, function (event, user) {
            if (user) {
                _this.isImpersonated = user.isImpersonated;
                if ((user.warnings && user.warnings.length) || (user.errors && user.errors.length)) {
                    self.Util.handleApiError({
                        data: {
                            errors: user.warnings.concat(user.errors)
                        },
                    }, self);
                }
                if (self.errors && self.errors.pageErrors) {
                    self.errors.pageErrors.forEach(function (error) {
                        if (error.code == 26) {
                            var myAccountLinkText = '<a href="/account/manage-certifications">My Account</a>';
                            error.showFullText = true;
                            if (error.message.indexOf(myAccountLinkText) === -1) {
                                error.message = error.message.replace(/My Account/g, myAccountLinkText);
                            }
                        }
                    });
                }
                _this.userIsLoggedIn = true;
                self.loggedInUser = user;
                self.welcomeUserPanel = false;
                self.blockCheckOut = user.blockCheckOut;
                self.orderService.getRecentOrders()
                    .then(function (recentOrders) {
                    self.recentOrders = recentOrders;
                    if (self.recentOrders.length == 0) {
                        self.isRecentOrder = true;
                    }
                    else {
                        self.isRecentOrder = false;
                    }
                });
            }
            else {
                _this.userIsLoggedIn = false;
            }
        }, true);
        //hide the support/my account menus if they are open when clicking outside
        $scope.closeAll = closeAll;
        function closeAll() {
            self.currentItem = null;
            self.currentMenuItem = null;
            self.mobileMenuToggle = null;
            self.trackingIndex = null;
        }
        //Fix for ES-1283
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            var stateName = toState.name;
            $scope.stateCurrentName = toState.name;
        });
        this.CartService.subscribe(this.$scope, function (event, cart) {
            self.items = cart.aresLineItems;
        });
    }
    NavbarController.prototype.$onInit = function () {
        var _this = this;
        this.getProductFilters();
        this.isMicrosoftBrowser = (!!window.MSInputMethodContext && !!document.documentMode) || /Edge/.test(navigator.userAgent);
        this.CartService.subscribeToCartSummary(this.$scope, function (event, data) {
            _this.quantityOfCartItems = data.itemCount;
            _this.subTotal = data.subtotal;
        });
        this.CartService.subscribeToSelectedCartChange(this.$scope, function (cartId) {
            _this.updateStateAndCartId(cartId);
        });
        this.ssoMergeFlagEnabledSub = this.unleashSvc.isEnabledObserveViaName('sso-merging').subscribe(function (isEnabled) {
            _this.ssoMergeFlagEnabled = isEnabled;
            if (_this.ssoMergeFlagEnabled && !_this.hasAddedNotification && _this.userIsLoggedIn) {
                _this.addEmailSentNotificationIfEligible();
                _this.hasAddedNotification = true;
            }
        });
        this.singleRegFeatureFlagEnabledSub = this.unleashSvc.isEnabledObserveViaName('ares-single-registration')
            .subscribe(function (isEnabled) {
            _this.singleRegFeatureFlagEnabled = isEnabled;
        });
        if (this.$location.search()) {
            if (this.$location.search()['sso']) {
                this.userEmail = decodeURIComponent(this.$location.search()['sso']);
                this.displaySsoModalOnlogin = true;
                this.displaySsoModal = true;
                this.ga.sendEvent('Unmerged SSO', 'Merge reminder email', 'Email sent', null);
            }
            if (this.$location.search()['isMergedAccount']) {
                this.isMergedAccount = true;
            }
        }
        if (!this.isMergedAccount) {
            this.checkMergedAccountSub = this.Auth.checkIfSsoMergeIsPossible(true).subscribe(function (isMergedAccount) {
                _this.isMergedAccount = isMergedAccount;
            });
        }
        this.unleashSvc.isEnabledObserveViaName('eev2-signup').subscribe(function (isEnabled) {
            if (isEnabled)
                _this.signupUrl = '/practitioner-signup';
        });
    };
    NavbarController.prototype.$onDestroy = function () {
        if (this.checkMergedAccountSub && !this.checkMergedAccountSub.closed) {
            this.checkMergedAccountSub.unsubscribe();
        }
        if (this.ssoMergeFlagEnabledSub && !this.ssoMergeFlagEnabledSub.closed) {
            this.ssoMergeFlagEnabled.unsubscribe();
        }
        if (this.singleRegFeatureFlagEnabledSub && !this.singleRegFeatureFlagEnabledSub.closed) {
            this.singleRegFeatureFlagEnabledSub.unsubscribe();
        }
    };
    NavbarController.prototype.closeSsoModal = function ($event) {
        this.displaySsoModalOnlogin = false;
        this.displaySsoModal = false;
        $event.close();
    };
    NavbarController.prototype.redirectToSignup = function () {
        window.location.href = this.signupUrl;
    };
    NavbarController.prototype.addEmailSentNotificationIfEligible = function () {
        var _this = this;
        this.Auth.checkIfSsoMergeIsPossible().subscribe(function (isEligible) {
            if (isEligible) {
                _this.addEmailSentNotification();
            }
        });
    };
    NavbarController.prototype.addEmailSentNotification = function () {
        var _this = this;
        var notification = new NotificationItem();
        notification.body = 'Now it\'s easier to access your Emerson Wholesale and Wellevate® Virtual Dispensary accounts through a single shared login.';
        notification.header = 'It\'s Time To Simplify Your Sign-in.';
        notification.actionText = ' Click here to create your shared login.';
        notification.status = NotificationStatus.New;
        notification.action = function (item) {
            _this.showEmailSentModal();
        };
        this.notificationBellService.add(notification);
    };
    NavbarController.prototype.showEmailSentModal = function () {
        var _this = this;
        this.Auth.getUserEmail().then(function (email) {
            _this.userEmail = email;
        });
        this.displaySsoModal = true;
    };
    NavbarController.prototype.getProductFilters = function () {
        this.ProductService.getDeliveryFormats();
        this.ProductService.getDietaryConsiderations();
        this.ProductService.getIngredients();
        this.ProductService.getCategories();
        this.ProductService.getBrands();
        this.ProductService.getTaxonomies();
        this.SearchService.getRecentSearches();
    };
    ;
    // Check if selected item(s) contain valid quantity
    NavbarController.prototype.checkInvalidRecentItems = function () {
        var invalidItems = this.cartList.findIndex(function (item) { return item.quantity == ''; });
        if (invalidItems > -1) {
            this.isValidRecentOrderQty = false;
        }
        else {
            this.isValidRecentOrderQty = true;
        }
    };
    NavbarController.prototype.toggleMobileShopItems = function (shopItemId) {
        // 1 = Condition, 2 = Category, 3 = Brand, 4 = New Products, 5 = Quality Partners
        if (shopItemId === this.mobileShopItemsOpen) {
            this.mobileShopItemsOpen = 0; // close the items
        }
        else {
            this.mobileShopItemsOpen = shopItemId;
        }
    };
    ;
    ;
    NavbarController.prototype.showWelcome = function () {
        return false;
    };
    NavbarController.prototype.updateSelectedCartId = function (cartId) {
        this.CartService.setCartId(cartId);
    };
    NavbarController.prototype.updateStateAndCartId = function (cartId) {
        var _this = this;
        this.CartService.getAllCarts(this.storeFrontId).then(function (res) {
            _this.multiCartList = res.data.body;
            var selectedCart = _this.multiCartList.find(function (x) { return x.cartId == cartId || (cartId == null && x.isActive); });
            if (selectedCart) {
                sessionStorage.setItem('currentCart', JSON.stringify(selectedCart));
                _this.selectedCartId = selectedCart.cartId;
                _this.CartService.getCartSummary();
                var reloadStates = ['cart', 'shippingAndDelivery', 'payment', 'reviewOrder', 'placedOrder'];
                if (reloadStates.includes(_this.$state.current.name)) {
                    _this.$state.reload();
                }
            }
        });
    };
    NavbarController.prototype.addInactiveCart = function () {
        this.CartService.createInactiveCart(this.storeFrontId);
    };
    NavbarController.prototype.loadCarts = function (cartId) {
        var _this = this;
        this.CartService.getAllCarts(this.storeFrontId).then(function (response) {
            _this.multiCartList = response.data.body;
            if (cartId != null) {
                var matchCart = _this.multiCartList.filter(function (ct) { return ct.cartId == cartId; })[0];
                sessionStorage.setItem('currentCart', JSON.stringify(matchCart));
                _this.selectedCartId = cartId;
            }
            else {
                var storedCart_1 = JSON.parse(sessionStorage.getItem('currentCart'));
                if (storedCart_1 != null && _this.multiCartList.filter(function (ct) { return ct.cartId == storedCart_1.cartId; })[0]) {
                    var machedCart = _this.multiCartList.filter(function (ct) { return ct.cartId == storedCart_1.cartId; })[0];
                    sessionStorage.setItem('currentCart', JSON.stringify(machedCart));
                    _this.selectedCartId = machedCart.cartId;
                    if (machedCart.isActive)
                        _this.CartService.initializeCartId(null);
                    else
                        _this.CartService.initializeCartId(machedCart.cartId);
                }
                else {
                    var defaultCart = _this.multiCartList.filter(function (ct) { return ct.isActive == true; })[0];
                    sessionStorage.setItem('currentCart', JSON.stringify(defaultCart));
                    _this.selectedCartId = defaultCart.cartId;
                    _this.CartService.initializeCartId(null);
                }
            }
        });
    };
    NavbarController.prototype.deleteInactiveCart = function () {
        var _this = this;
        var selectedCart = this.multiCartList.find(function (x) { return x.cartId == _this.selectedCartId; });
        if (selectedCart && selectedCart.isActive === false && this.quantityOfCartItems == 0) {
            this.CartService.deleteInactiveCart(this.storeFrontId);
        }
        else {
            if (selectedCart.isActive) {
                window.alert('Can\'t delete customer cart');
            }
            else {
                window.alert('Please remove items before deleting the cart.');
            }
        }
    };
    NavbarController.prototype.appTabLinkClicked = function (small) {
        if (small === void 0) { small = false; }
        var linkToGoTo = 'https://www.fullscript.com/wellevate-practitioner'; //this.environmentConfiguration.wellevateAppTabLinks.appTabLinkMerged;
        var linkToGoToGuest = 'https://www.fullscript.com/';
        if (linkToGoTo) {
            if (this.userIsLoggedIn) {
                if (this.isMergedAccount) {
                    this.ga.sendEvent('Merged SSO', 'click', 'App tab navigate to WV', null);
                }
                else {
                    this.ga.sendEvent('Unmerged SSO', 'click', 'App tab navigate to WV', null);
                }
                window.open(linkToGoTo);
            }
            else {
                this.ga.sendEvent('User', 'click', 'App tab navigate to WV', null);
                window.open(linkToGoToGuest);
            }
        }
    };
    return NavbarController;
}());
export default NavbarController;
//# sourceMappingURL=navbar.controller.js.map